// returned from the "sendMessage" function in ServiceWorkerHelper.js
export class ServiceWorkerSendMessageResponse {
    successfull;
    result;
    constructor(aSuccessfull, aResult) {
        this.successfull = aSuccessfull;
        this.result = aResult;
    }
}